import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AbstractCallComponent } from '../abstract-call/abstract-call.component';
import { fillTemplateWithData } from '../../routines';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'se-tab-window-call',
    templateUrl: './tab-window-call-component.component.html',
    styleUrls: ['../call-style/call.scss'],
})
export class TabWindowCallComponentComponent extends AbstractCallComponent implements OnInit, AfterViewInit {
    url: SafeResourceUrl | null = null;
    tabWindow: Window | null = null;

    constructor() {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();
        const url = this.parseUrlWithData();
        this.tabWindow = window.open(url, '_blank');
        if (!this.tabWindow) return;
    }

    parseUrlWithData = (): string => {
        if (!this.call.url) return '';
        if (this.dataStore) {
            return fillTemplateWithData(this.dataStore, this.call.placeholders, this.call.url);
        } else {
            return this.call.url;
        }
    };

    ngAfterViewInit(): void {
        if (this.url) this.showLoading = true;
    }

    onCloseChildWindow() {
        if (!this.tabWindow) return this.close();
        this.tabWindow.close();
        this.close();
    }

    close(): void {
        this.end();
    }
}
